import axiosClient from './axiosClient';

export const gmpService = {
  /**
   * Fetch grey-market premium for every tracked IPO
   * @param {boolean} force - Force the backend to re-scrape instead of serving its cache
   */
  getGmp: async (force = false) => {
    const response = await axiosClient.get('/api/market/gmp', {
      params: { force },
    });
    return response.data;
  },

  /**
   * Fetch grey-market premium for SME IPOs only (NSE Emerge & BSE SME)
   */
  getSmeGmp: async () => {
    const response = await axiosClient.get('/api/market/gmp/sme');
    return response.data;
  },

  /**
   * Fetch GMP for one company (loose match: "A-One Steels" and "a-one-steels" both resolve)
   * @param {string} company - Company name or URL slug
   */
  getGmpByCompany: async (company) => {
    const response = await axiosClient.get(`/api/market/gmp/${encodeURIComponent(company)}`);
    return response.data;
  },
};

export default gmpService;
